import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track5DRed = ({ state, workState, onLabelClick }) => (
	<g id="Track5DRed" transform="translate(1484.000000, 758.000000)" className="track">
		<g id="line" transform="translate(0.981601, -0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M197.581811,19.0149805 L59.9270068,72.8208482 C39.3517114,80.8632236 15.980169,76.2530909 -2.84217094e-14,61 L-2.84217094e-14,61 L-2.84217094e-14,61"/>
			<path
				d="M251.483113,12.7559955 C248.596638,5.68069016 240.564718,2.2331092 233.447427,5.01444897 L209.084339,14.5352097 L209.084339,14.5352097"/>
			<TrackArrow
				transform="translate(210.810333, 13.778477) rotate(-22.000000) translate(-210.810333, -13.778477) "
				points="214.810333 21.7784769 206.810333 13.7784769 214.810333 5.77847694"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track5DRed')}
			coords="134.259644, 17.005074"
			text="5D"
			textCoordsX="9.76025391"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

Track5DRed.propTypes = trackPropTypes;

export default Track5DRed;
